import { render, staticRenderFns } from "./TTTextArea.vue?vue&type=template&id=6c3614ee&scoped=true"
import script from "./TTTextArea.vue?vue&type=script&lang=js"
export * from "./TTTextArea.vue?vue&type=script&lang=js"
import style0 from "./TTTextArea.vue?vue&type=style&index=0&id=6c3614ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3614ee",
  null
  
)

export default component.exports